export default __webpack_public_path__ + "static/predis-logo-h100px-gray-1010234ed3e9d750f3589b100e831166.png";